export default __webpack_public_path__ + "static/media/woods.0a1a2027.jpg";